import React from "react";
import { FieldArray, FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { AdvancePaymentFormValues } from "src/models/AdvancePayment.model";
import { handleValidNumber } from "src/utils/validations/numberInput";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import { handleValidNumber2 } from "src/utils/formUtils/ValidNumber";

type Props = {
  formikProps: FormikProps<AdvancePaymentFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
  onlineMode?: any[];
};

const AdvancePayment = ({ formikProps, onClose, formType,onlineMode }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  

  const userOption = [
    {
      label: "Student",
      value: "STUDENT",
    },
    {
      label: "Franchise",
      value: "FRANCHISE",
    },
  ];

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD"
            ? "Add Advance Payment"
            : "Update Advance Payment"}{" "}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          <div>
            <ATMTextField
              placeholder="Enter Name"
              name="name"
              value={values.name}
              required
              onChange={(e) => {
                setFieldValue("name", e.target.value);
              }}
              label="Name"
              onBlur={handleBlur}
            />
          </div>
          <div>
            <ATMTextField
              placeholder="Enter Mobile"
              name="mobile"
              value={values.mobile}
              required
              onChange={(e) => {
                handleValidNumber(e) && setFieldValue("mobile", e.target.value);
              }}
              label="Mobile Number"
              onBlur={handleBlur}
            />
          </div>
          <div>
            <ATMSelect
              name="userType"
              required
              placeholder=" Select User Type"
              label=" User Type"
              options={userOption}
              onChange={(newValue: any) => {
                setFieldValue("userType", newValue);
              }}
              value={values?.userType}
            />
          </div>
          <div>
            <ATMTextField
              name="remark"
              value={values.remark}
              required
              placeholder="Enter remark"
              onChange={(e) => {
                setFieldValue("remark", e.target.value);
              }}
              label="Remark"
            />
          </div>
          <div>
            <ATMTextField
              placeholder="Enter Total Amount"
              name="amount"
              value={values.amount}
              required
              onChange={(e) => {
                handleValidNumber(e) && setFieldValue("amount", e.target.value);
              }}
              label="Total Amount (A)"
              onBlur={handleBlur}
            />
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300">
            <thead className="bg-gray-100 text-left">
              <tr>
                <th className="border px-4 py-2">Note Value</th>
                <th className="border px-4 py-2">Quantity</th>
                <th className="border px-4 py-2">Total Amount</th>
              </tr>
            </thead>
            <tbody>
              <FieldArray name="paymentMode">
                {() =>
                  values.paymentMode.filter((item)=> item.type==="PHYSICAL").map((note, index) => {
                    const quantityValue = note.quantity || "";

                    return (
                      <tr key={index}>
                        <td className="border px-4 py-2">{note.name} X</td>
                        <td className="border px-4 py-2">
                          <ATMTextField
                            name={`paymentMode[${index}].quantity`}
                            value={values.paymentMode[index].quantity}
                            onChange={(e) =>
                              handleValidNumber2(e) &&
                              setFieldValue(
                                `paymentMode[${index}].quantity`,
                                e.target.value
                              )
                            }
                            placeholder="Enter quantity"
                            onBlur={handleBlur}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          {note.value * Number(quantityValue || 0)}
                        </td>
                      </tr>
                    );
                  })
                }
              </FieldArray>
            </tbody>
          </table>
        </div>
         <div className="border rounded-md p-1">
            <table className="w-full border text-left">
              <thead>
                <tr className="bg-gray-100 text-sm">
                  <th className="p-2">Payment In</th>
                  <th className="p-2">Amount</th>
                </tr>
              </thead>
              <tbody>
                {onlineMode?.map((mode, i) => {
                  const item = values.paymentMode.find(
                    (item) => item.name === mode.label
                  ) || { value: 0 }; // Changed to use value

                  return (
                    <tr key={i} className="border-t">
                      <td className="p-2">{mode.label}</td>
                      <td className="p-2">
                        <ATMTextField
                          name={`paymentMode_${mode.value}`}
                          value={item.value.toString()} // Using value instead of quantity
                          onChange={(e) => {
                            const amount = e.target.value;
                            if (
                              handleValidNumber2({
                                target: { value: amount },
                              } as React.ChangeEvent<HTMLInputElement>)
                            ) {
                              const newInflow = values.paymentMode.filter(
                                (item) => item.name !== mode.label
                              );

                              if (amount) {
                                newInflow.push({
                                  name: mode.label,
                                  value: Number(amount), 
                                  quantity: 1, 
                                  type: mode.type,
                                });
                              }

                              setFieldValue("paymentMode", newInflow);
                            }
                          }}
                          onBlur={handleBlur}
                          label=""
                          placeholder="Amount"
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default AdvancePayment;
